<div class="calendar">
  <div class="calendar-header">
    <button
      type="button"
      class="nav-btn"
      [disabled]="isPreviousDisabled()"
      [attr.aria-label]="'Previous month'"
      (click)="goPreviousMonth()"
    >
      <mat-icon fontSet="material-icons-round">chevron_left</mat-icon>
    </button>
    <span class="kbody-medium month-label">{{ monthLabel }}</span>
    <button
      type="button"
      class="nav-btn"
      [attr.aria-label]="'Next month'"
      (click)="goNextMonth()"
    >
      <mat-icon fontSet="material-icons-round">chevron_right</mat-icon>
    </button>
  </div>

  <div class="weekday-row">
    <div class="weekday klabel-medium" *ngFor="let label of weekdayLabels">
      {{ label }}
    </div>
  </div>

  <div class="weeks">
    <div class="week" *ngFor="let week of weeks">
      <button
        type="button"
        class="day"
        *ngFor="let cell of week"
        [class.selected]="cell.isSelected"
        [class.out-of-month]="!cell.inMonth"
        [class.past]="cell.isPast"
        [class.today]="cell.isToday"
        [class.has-conflict]="cell.hasConflict && cell.isSelected"
        [disabled]="cell.isPast || !cell.inMonth"
        [attr.aria-pressed]="cell.isSelected"
        [attr.aria-label]="cell.iso"
        (click)="toggleDay(cell)"
      >
        <span class="day-number">{{ cell.dayNumber }}</span>
        <mat-icon
          *ngIf="cell.hasConflict && cell.isSelected"
          class="conflict-icon"
          fontSet="material-icons-round"
        >warning</mat-icon>
      </button>
    </div>
  </div>
</div>
